/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { __core_private__ as r } from '@angular/core';
export var /** @type {?} */ isPromise = r.isPromise;
export var /** @type {?} */ isObservable = r.isObservable;
//# sourceMappingURL=private_import_core.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/forms/src/private_import_core.js
// module id = 428
// module chunks = 4